export enum InvoiceStatus {
  /** Invoice is being built and has not been finalized or sent. */
  Draft = 'Draft',
  /** Invoice has been finalized and sent; awaiting customer payment. */
  Open = 'Open',
  /** Customer has paid the full amount due. Only set via webhook. */
  Paid = 'Paid',
  /** Invoice was voided before payment was collected. */
  Void = 'Void',
  /** Payment was not collected and the invoice has been written off. */
  Uncollectible = 'Uncollectible',
}
